import { Box, Typography } from "@mui/material";
import styles from "./RegenerationLoader.module.css";

const RegenerationLoader = ({ type = "sales-order" }) => {
  const isEstimate = type === "estimate";
  const isPresentation = type === "presentation";
  const title = isPresentation
    ? "Presentation regeneration in progress..."
    : isEstimate
      ? "Estimate regeneration in progress..."
      : "Sales order regeneration in progress...";
  const subtitle = isPresentation
    ? "Your presentation is being rebuilt with the latest cart changes."
    : isEstimate
      ? "Your estimate is being rebuilt with the latest cart changes."
      : "Your sales order is being rebuilt with the latest cart changes.";

  return (
    <Box
      className={styles.container}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <Box className={styles.illustration} aria-hidden="true">
        <svg
          className={styles.icon}
          viewBox="0 0 96 96"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="26"
            y="20"
            width="44"
            height="56"
            rx="8"
            className={styles.document}
          />
          <path d="M36 40H60" className={`${styles.line} ${styles.lineOne}`} />
          <path d="M36 50H60" className={`${styles.line} ${styles.lineTwo}`} />
          <path d="M36 60H54" className={`${styles.line} ${styles.lineThree}`} />
        </svg>
      </Box>
      <Box className={styles.copy}>
        <Typography variant="body1" className={styles.title}>
          {title}
        </Typography>
        <Typography variant="body2" className={styles.label}>
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default RegenerationLoader;
